<div class="flex items-center">
  <p-menu #userMenu [popup]="true" [model]="userMenuItems">
    <ng-template #item let-item>
      <a pRipple class="flex items-center p-menu-item-link">
        @if (item.icon) {
          <span class="material-symbols-outlined">
            {{ item.icon }}
          </span>
        }
        <span class="ml-2">{{ item.label }}</span>

        @if (item.badge) {
          <p-badge class="ml-auto" [value]="item.badge" />
        }

        @if (item.shortcut) {
          <span
            class="p-1 ml-auto text-xs border rounded border-surface bg-emphasis text-muted-color"
          >
            {{ item.shortcut }}
          </span>
        }
      </a>
    </ng-template>
  </p-menu>

  <button
    (click)="userMenu.toggle($event)"
    class="flex items-center justify-between gap-3 px-3 py-2 transition-colors rounded-full hover:bg-gray-50"
  >
    <div class="flex items-center flex-shrink-0 gap-3">
      <!-- Avatar com iniciais -->
      <div
        class="w-10 h-10 rounded-full bg-[var(--p-background-50)] flex items-center justify-center flex-shrink-0"
      >
        <span class="text-sm font-medium text-[var(--p-primary-500)]">{{
          userInitials
        }}</span>
      </div>
      <!-- Nome do usuário -->
      <span
        class="overflow-hidden text-base font-medium text-black whitespace-nowrap text-ellipsis"
        >{{ userName }}</span
      >
    </div>
    <!-- Ícone de seta -->
    <i class="material-symbols-outlined"> keyboard_arrow_down </i>
  </button>
</div>
